"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./SearchFilter.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _CustomForm = _interopRequireDefault(require("../../form/CustomForm"));

var _CustomInput = _interopRequireDefault(require("../../form/CustomInput"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _Propulator = _interopRequireDefault(require("../../../../higher-order/Propulator"));

var _class, _class2, _descriptor, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var SearchFilter = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchFilter, _React$Component);

  var _super = _createSuper(SearchFilter);

  function SearchFilter() {
    var _this;

    _classCallCheck(this, SearchFilter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "isFocused", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(SearchFilter, [{
    key: "handleSearchSubmit",
    value: function handleSearchSubmit(e) {
      if (this.props.tableModel) {
        this.props.tableModel.updateFilter(this.props.filterModel.key, this.props.filterModel.searchValue, this.props.dispatcher);
      }

      if ((0, _isFunction.default)(this.props.onSubmit)) {
        this.props.onSubmit(e);
      }

      this.isFocused = false;
      e.preventDefault(); // prevent cancel button from receiving event
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      this.isFocused = true;
    }
  }, {
    key: "handleSearchClear",
    value: function handleSearchClear(e) {
      if (this.props.tableModel) {
        this.props.tableModel.updateFilter(this.props.filterModel.key, "", this.props.dispatcher);
      }

      if ((0, _isFunction.default)(this.props.onClear)) {
        this.props.onClear(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var inputClasses = (0, _classnames.default)("search-input", {
        "has-value": !(0, _isEmpty.default)(this.props.filterModel.value),
        "has-focus": this.isFocused
      });
      return /*#__PURE__*/_react.default.createElement(_CustomForm.default, {
        form: this.props.filterModel.searchForm,
        className: "search-filter",
        showFormLevelErrors: false
      }, /*#__PURE__*/_react.default.createElement(_CustomInput.default, {
        fieldName: "searchValue",
        className: inputClasses,
        placeholder: this.props.filterModel.placeholder || "Search...",
        onFocus: this.handleFocus,
        onBlur: this.handleSearchSubmit,
        autoComplete: "off",
        inputDisabled: this.props.disableUntilTableModelLoaded && this.props.tableModel && !this.props.tableModel.isLoaded
      }), !(0, _isEmpty.default)(this.props.filterModel.value) && /*#__PURE__*/_react.default.createElement("button", {
        className: "search-clear",
        title: "Clear search",
        onClick: this.handleSearchClear
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-cancel"
      })), (0, _isEmpty.default)(this.props.filterModel.value) && /*#__PURE__*/_react.default.createElement("button", {
        type: "submit",
        title: "Search",
        className: "search-submit"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-search"
      })));
    }
  }]);

  return SearchFilter;
}(_react.default.Component), _defineProperty(_class3, "propTypes", {
  filterModel: _mobxReact.PropTypes.objectOrObservableObject.isRequired,
  dispatcher: _mobxReact.PropTypes.objectOrObservableObject.isRequired,
  disableUntilTableModelLoaded: _propTypes.default.bool
}), _class3), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "isFocused", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "handleSearchSubmit", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleSearchSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleFocus", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleFocus"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleSearchClear", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleSearchClear"), _class2.prototype)), _class2)) || _class;

var _default = (0, _Propulator.default)(SearchFilter, {});

exports.default = _default;